import Constants from '@utils/constants';

export const isDevOrTestEnv = () =>
    [
        Constants.environment.LOCAL,
        Constants.environment.DEV,
        Constants.environment.DEV1,
        Constants.environment.DEV2,
        Constants.environment.TEST,
        Constants.environment.TEST1,
        Constants.environment.TEST2,
    ].includes(window.environment);
